var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepsiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9y2pqoc08a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11",
    style: {
      fill: "none"
    },
    d: "M0 0h104v104H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150",
    style: {
      clipPath: "url(#9y2pqoc08a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M53.663 3.323a50.34 50.34 0 1 1-50.34 50.34 50.34 50.34 0 0 1 50.34-50.34",
    transform: "translate(-1.393 -1.932)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M52.27 1.391a50.34 50.34 0 1 1-50.34 50.34 50.34 50.34 0 0 1 50.34-50.34m0-1.93A52.283 52.283 0 0 0 31.923 99.892 52.283 52.283 0 0 0 72.616 3.569 51.945 51.945 0 0 0 52.27-.539"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M16 37.556a61.218 61.218 0 0 0 18.878 3.305c15.791 0 32.2-5.84 48.467-5.84 7.106 0 13.572.8 18.588 2.535A46.888 46.888 0 0 0 59.017 9.381 47.391 47.391 0 0 0 16 37.556",
    transform: "translate(-6.707 -4.472)",
    style: {
      fill: "#ff1400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M101.977 119.82a61.218 61.218 0 0 0-18.877-3.305c-15.791 0-32.2 5.84-48.467 5.84-7.106 0-13.572-.8-18.588-2.535a46.888 46.888 0 0 0 42.915 28.174 47.391 47.391 0 0 0 43.019-28.174",
    transform: "translate(-6.726 -49.385)",
    style: {
      fill: "#0e0e96"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M29.256 42.007h16.8v4.8H35.911v2.482h7.975v4.615h-7.975v2.482h10.258v4.8H29.256zm59.5 19.174h6.779V41.698l-6.732 2.385zm-21.63-4.211c1.263 3.285 5.034 4.851 10.654 4.851 5.351 0 9.088-2.3 9.088-6.358 0-7.037-11.929-5.294-11.929-7.86 0-.745.862-1.31 2.388-1.31 2.115 0 3.276.678 3.705 2.045l5.391-2.039c-.677-2.68-3.377-4.726-9.292-4.726-4.984 0-8.665 2.152-8.665 6.1 0 7.341 11.93 5.449 11.93 8.158 0 .819-.847 1.31-2.656 1.31-2.717 0-4.534-.675-5.269-2.182zm-46.729-1.23-4.782 1.788v3.653H8.957V42.01h10.37c5.388 0 8.075 2.314 8.075 6.421 0 4.254-2.963 5.825-7.005 7.309m-2.084-8.938h-2.7v5.751l2.52-1.019c1.613-.6 2.521-1.318 2.521-2.8 0-1.222-.861-1.928-2.342-1.928m41.969 8.938-4.782 1.788v3.649h-6.657V42.01h10.37c5.388 0 8.075 2.314 8.075 6.421 0 4.254-2.963 5.825-7.005 7.309m-2.084-8.938h-2.7v5.751l2.52-1.019c1.613-.6 2.521-1.318 2.521-2.8 0-1.222-.861-1.928-2.342-1.928"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepsiLogo);
export default __webpack_public_path__ + "static/media/PepsiLogo.2454e2359478151966596e6e9f827850.svg";
export { ForwardRef as ReactComponent };